/**
 * Feature flags — keep code in place; flip to true when ready to ship.
 * Audit Trail UI is deferred (~2–3 months).
 */
export const AUDIT_TRAIL_ENABLED = false;
